import React from "react";
import { arrayOf, shape, string } from "prop-types";
import {
	ShareDownloadsButtonsContainer,
	ShareDownloadsButtonsRow,
	ShareDownloadsParagraph,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";
import { useLocale } from "@insightfulscience/i18";
import ShareDownloadLinkItem from "./ShareDownloadsLinkItem";

const renderDownloadLink = download => download != null && <ShareDownloadLinkItem {...download} />;

const ShareDownloadLinks = ({ items, productVersion }) => {
	const [t] = useLocale("share-downloads-links");
	const downloads = React.useMemo(
		() => new Map(items.map(item => [item.os, item])),
		[items], //
	);

	return (
		<>
			<ShareDownloadsParagraph className="mb-10">
				{t("TITLE", {
					version: productVersion,
				})}
			</ShareDownloadsParagraph>
			<ShareDownloadsButtonsContainer>
				<ShareDownloadsButtonsRow>
					{renderDownloadLink(downloads.get("mac"))}
					{renderDownloadLink(downloads.get("windows"))}
				</ShareDownloadsButtonsRow>
				<ShareDownloadsButtonsRow>
					{renderDownloadLink(downloads.get("linux_deb"))}
					{renderDownloadLink(downloads.get("linux_rpm"))}
				</ShareDownloadsButtonsRow>
			</ShareDownloadsButtonsContainer>
		</>
	);
};

ShareDownloadLinks.propTypes = {
	items: arrayOf(
		shape({
			os: string,
			id: string,
			minOSVersion: string,
			minOSName: string,
			downloadLink: string,
		}),
	).isRequired,
	productVersion: string.isRequired,
};

export default ShareDownloadLinks;
